// AGC: Wagmi configuration for Base App (Farcaster) builds
// AGC: Uses farcasterMiniApp connector for Base App wallet integration

import { createConfig, type Config, http } from 'wagmi'
import { base, baseSepolia } from 'wagmi/chains'
import { farcasterMiniApp } from '@farcaster/miniapp-wagmi-connector'
import { getAppMetadata } from './app-metadata'

let cachedConfig: Config | null = null

// AGC: Get RPC URLs from environment
const baseSepoliaRpc =
  import.meta.env.VITE_BASE_SEPOLIA_RPC_URL ||
  import.meta.env.VITE_BASE_RPC_URL ||
  'https://sepolia.base.org'

const baseMainnetRpc =
  import.meta.env.VITE_BASE_MAINNET_RPC_URL ||
  'https://mainnet.base.org'

/**
 * AGC: Create Farcaster/Base App wagmi config
 */
const createFarcasterConfig = (): Config => {
  const metadata = getAppMetadata()
  
  return createConfig({
    chains: [baseSepolia, base],
    connectors: [
      farcasterMiniApp({
        appName: metadata.name,
        appIconUrl: metadata.icon,
        rpcUrl: baseSepoliaRpc,
        metadata: {
          name: metadata.name,
          description: metadata.description,
          url: metadata.url,
          iconUrl: metadata.icon,
        },
      }),
    ],
    transports: {
      [base.id]: http(baseMainnetRpc),
      [baseSepolia.id]: http(baseSepoliaRpc),
    },
  })
}

/**
 * AGC: Get cached Farcaster config (singleton pattern)
 */
export const getFarcasterConfig = (): Config => {
  if (!cachedConfig) {
    cachedConfig = createFarcasterConfig()
  }
  return cachedConfig
}

/**
 * AGC: Reset cached config (useful when metadata changes)
 */
export const resetFarcasterConfig = () => {
  cachedConfig = null
}

